import { useState, useRef } from "react";
import getArea, { AreaTelefonica } from "./getArea";
import validatePhone from "./validatePhone";

const MOBILE_PHONES_DIGITS_LENGTH = 13;

export interface PhoneValue {
  number: string;
  isMobile: boolean;
  area: AreaTelefonica | null;
  touched: boolean;
  error: string | null;
}

const usePhone = (number: string = "") => {
  const inputRef = useRef<HTMLInputElement | null>(null);

  const [value, setValue] = useState<PhoneValue>({
    number,
    isMobile:
      number.length === MOBILE_PHONES_DIGITS_LENGTH || number.length === 0,
    area: getArea(number),
    touched: false,
    error: null,
  });

  const onNumberChange = (event: { target: { value: string } }) => {
    const rawNumber = event.target.value;
    const number = rawNumber.replace(/\s|\(|\)|-|_/g, "");

    const area = getArea(number);

    const error = validatePhone(number, value.isMobile, area);

    setValue((current) => ({
      ...current,
      touched: false,
      area,
      error,
      number: number,
    }));
  };

  const onNumberBlur = () => {
    const error = validatePhone(value.number, value.isMobile, value.area);

    setValue((current) => ({ ...current, error, touched: true }));
  };

  const onIsMobileChange = (event: { target: { value: boolean } }) => {
    const isMobile = event.target.value;

    setValue((current) => ({
      ...current,
      number: "",
      touched: false,
      isMobile,
    }));

    if (inputRef.current) setTimeout(() => inputRef.current?.focus(), 0);
  };

  const setTouched = (touched: boolean) => {
    setValue((current) => ({ ...current, touched }));
  };

  return [
    inputRef,
    value,
    setTouched,
    onNumberChange,
    onNumberBlur,
    onIsMobileChange,
  ] as const;
};

export default usePhone;
